import React, { useMemo } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { X } from "lucide-react";

const normalizeComments = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value.filter(Boolean);
  return [value];
};

const getCommentText = (comment) => {
  if (comment == null) return "-";
  if (typeof comment === "string") return comment;
  return comment?.text || comment?.message || comment?.comment || "-";
};

const getCommentDate = (comment) => {
  if (!comment || typeof comment !== "object") return null;
  const dateValue = comment?.createdAt || comment?.updatedAt || comment?.date;
  return dateValue ? new Date(dateValue).toLocaleString() : null;
};

const SubtaskCommentsDialog = ({ open, onClose, subtask }) => {
  const comments = useMemo(
    () => normalizeComments(subtask?.comments),
    [subtask?.comments]
  );

  const locationLabel =
    subtask?.locationName || subtask?.locationNumber || "Subtask";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: "20px" },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 1,
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          Comments ({comments.length}) — {locationLabel}
        </Typography>
        <IconButton onClick={onClose} size="small" aria-label="close">
          <X size={20} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 0, pb: 3 }}>
        {comments.length ? (
          <Stack gap={1.5}>
            {comments.map((comment, idx) => (
              <Box
                key={comment?._id || idx}
                sx={{
                  p: 1.5,
                  borderRadius: "14px",
                  border: "1px solid #ececec",
                  bgcolor: "#fafafa",
                }}
              >
                <Typography fontSize={13} color="#333" lineHeight={1.5}>
                  {getCommentText(comment)}
                </Typography>
                {getCommentDate(comment) && (
                  <Typography fontSize={11} color="text.secondary" mt={0.75}>
                    {getCommentDate(comment)}
                  </Typography>
                )}
              </Box>
            ))}
          </Stack>
        ) : (
          <Typography fontSize={13} color="text.secondary">
            No comments found for this subtask.
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SubtaskCommentsDialog;
